import { CustomerEvent, Reviews } from '@backend/domain'
import { Injectable } from '@nestjs/common'
import { InjectRepository } from '@nestjs/typeorm'
import { Repository } from 'typeorm'
import { UserModifiableEntityRepository } from './generic'

@Injectable()
export class ReviewsRepository extends UserModifiableEntityRepository<Reviews> {
	constructor(@InjectRepository(Reviews) override readonly _repository: Repository<Reviews>) {
		super(_repository)
	}
}

@Injectable()
export class CustomerEventRepository extends UserModifiableEntityRepository<CustomerEvent> {
	constructor(@InjectRepository(CustomerEvent) override readonly _repository: Repository<CustomerEvent>) {
		super(_repository)
	}
}
